export const SOCKET_URL =
  (import.meta.env.VITE_TMUX_SOCKET_URL as string | undefined) ||
  "http://localhost:4001";

export const SESSION_PRESETS: { server: string; sessions: string[] }[] = [
  {
    server: "Wialon",
    sessions: [
      "AAMER_CANACAR_GECKOTECH_WS", "AAMER_TRANSPLACE_WS", "ACTRANSPORTE_CANACAR_GECKOTECH_WS",
      "AEANDRADE_Dicka_RC", "AMESIS", "AUTOEXXPRES45_SOLISTICA_RC", "BOSQUES2017_DHL_RC",
      "BOSQUES2017_NISSAN_RC_WS", "CAMACHO2018_SOFTYS_RC", "CDPUERTO_SKY_WS",
      "DAGO_HomeDepot_RC_WS", "DAGO_arcelormittal_SITRACK", "EARANDA25_RC_WS",
      "ELISEO_sitrack_ws", "FLOCAEXPRESS_SITRACK_WS", "FRGC2020", "FRGC2020_BLACSOLUTIONS_WS",
      "FRGC2020_MABE_skyangel_WS", "FRGCWS_Walmart", "Frgc2020_webtracker_WS",
      "Frgc_bafar_WideTech_WS", "GAMI_MABE_SKYANGEL_WS", "GAMI_QS3_WS", "GAMI_TRANSPLACE_RC_WS",
      "GOPASA_Transplace_RC", "JAGO_WS_RC", "JPRADO_BLACSOLUTIONS_WS", "MAVILA_WS_SIS",
      "OMARLAG_UNIGIS_KIMBERLY", "PACIFICOOL_RC_WS", "PENINSULAYSUR_ENVASESUNIVERSALES_RC_WS",
      "PNT_CHEDAUI_RC_WS", "PNT_RC_Walmart_WS", "R-HHS_KROHN_WS", "SESE_NEXO", "SESE_SOAPUI_WS",
      "TRANSPORTESCARIZAR_RC_WS", "TRANSPORTESMUMA_UNIGIS_WS", "TRANSPORTESRAQUEL_LEMADWS",
      "TRANSPORTESRAQUEL_RC_DHLWS", "TRANSPORTESRAQUEL_SOLISTICA_RC", "TRANSPORTESRAQUEL_WS_ASSISTCARGO",
      "TRANSVERO_Driving_WS", "TRCMTY_RC_Walmart", "WS_Sitrack", "XTCS_HOMEDEPOT_RC_WS",
      "camacho2018_ungis", "estadisticas_api", "fletexpress_project44_api", "frikarmex_pack2go_RC_ws",
      "r-tsterke_WHIRPOOL_RC_WS",
    ],
  },
  {
    server: "DUMAX v4",
    sessions: [
      "AMESIS", "ASERRANO_LANDSTAR_WS", "CLO-ORIVER_RC_WS", "GrupoPeak_CLOROX_RC_WS",
      "JJVAZQUEZ_BARCEL_alephri_ws", "JJVAZQUEZ_BIMBO_RC_WS", "LOESA_RC_WS", "MADERASSLP_LANDSTAR_WS",
      "RAFAGAS_SOLISTICA_RC", "RFERNANDEZC_ENVASESUNIVERSALES_RC_WS", "SORIA24_RXO_RC_WS",
      "TLBTRANSPORTES_ENVASESUNIVERSALES_RC", "TNREGIO_RC_WS", "TRANSPORTESCARIZAR_RC_WS",
      "Telopez_CHEP_ALTOTRACKWS", "gochat", "gomail", "gops_topfly", "grupopeak_pack2go_RC_ws",
      "javearredondo_transplace_RC_WS", "kronh_telopez", "mapi", "quecklink", "tcp_gops",
      "telopez_bimbo", "transgaly_SHIELD_RC_WS", "udp_gops", "yoset_recursoconfiable_lemad_ws"
    ],
  },
  {
    server: "V2",
    sessions: [
      "ASGP_PENSKE_QS3WS", "AVERGARA_UNIGIS_WS", "AYVIWS_RC", "BOSQUES_RC_DHLWS",
      "CANYWS_CTTMX_SUKARNE", "FRGC2020_SORIANA_WS", "FRGC2020_SORIANA_WS_REST",
      "HERON_SOLUCIONES_ASSISTCARGO_WS_UNIGIS", "HERON_SOLUCIONES_RECURSOCONFIABLE_SOLISTICA_WS",
      "IMEC_CHURCHILL_KAFLA", "NEW_PASA", "PASA", "PCAMARENA", "POVATRANSPORT_SKY_MABEWS",
      "RGC_CTTMX_SUKARNEWS", "SEREVE_UNIGIS_KIMBERLYCLARKWS", "Salmar", "SuKarne",
      "TMAXIMA_FREIGHTVERIFYWS", "TRANSPORTESRAQUEL_LEMADWS", "TransportesRaquel",
      "VILLASENOR_RECURSOCONFIABLE_WS", "WSTESPEJEL_UNIGIS_ALEGOJI", "XTCS_ALTOMOVUP_FCA",
      "XTCS_RECURSOCONFIABLE_HOME_DEPOT_WS", "XTCS_solistica_recursoconfiableWS", "Xoxocotla",
      "alegoji_unigis_alpuraWS", "alpha19_essity_rc", "altotrack", "bafar_jumber_cttmxWS",
      "balandranWS_RC", "central_rc", "copesu_unigis_alpuraws", "floca_express_RC", "flocaexpress",
      "gemaws2020", "imec", "impuls", "joseggomez", "krnonh", "larmont", "lemad_BOSQUES2017WS",
      "old_xoxocotla", "pcamarena_blac_alimentosWS", "povatransport_unigis_mabews", "queue_handler",
      "recursoconfiable_RC", "ruja", "sukarne_rc", "t_pinguino", "telopez_chep_altotrack",
      "telopez_solistica_recursoconfiableWS", "tmarin_unigis", "tmartinezWS_RC", "trafimex_rc",
      "travilsa_rc", "villarica_RC", "wsRecursoConfiable_rc", "wsrecursco_RC", "wszukarmex",
    ],
  },
];
